<template>
  <div class="content-wrapper flex flex-direction flex-sub padding-sm">
    <div class="chart-map">
      <div ref="map" class="map"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/province/beijing'
import {serviceTeamData} from "@/api/weilao";

export default {
  name: "BuildingMap",
  components: {},
  data() {
    return {
      colors: [{
        name: '延庆区',
        itemStyle: {
          areaColor: '#c28fce',
          color: '#c28fce'
        }
      }, {
        name: '西城区',
        itemStyle: {
          areaColor: '#7b769d',
          color: '#7b769d'
        }
      }, {
        name: '朝阳区',
        itemStyle: {
          areaColor: '#9fd0bb',
          color: '#9fd0bb'
        }
      }, {
        name: '顺义区',
        itemStyle: {
          areaColor: '#ee908e',
          color: '#ee908e'
        }
      }, {
        name: '石景山区',
        itemStyle: {
          areaColor: '#e9d893',
          color: '#e9d893'
        }
      }, {
        name: '海淀区',
        itemStyle: {
          areaColor: '#d38c7c',
          color: '#d38c7c'
        }
      }, {
        name: '怀柔区',
        itemStyle: {
          areaColor: '#e6b490',
          color: '#e6b490'
        }
      }, {
        name: '房山区',
        itemStyle: {
          areaColor: '#62c3df',
          color: '#62c3df'
        }
      }, {
        name: '通州区',
        itemStyle: {
          areaColor: '#b9dfa1',
          color: '#b9dfa1'
        }
      }, {
        name: '丰台区',
        itemStyle: {
          areaColor: '#f0acb2',
          color: '#f0acb2'
        }
      }, {
        name: '昌平区',
        itemStyle: {
          areaColor: '#f5ccd7',
          color: '#f5ccd7'
        }
      }, {
        name: '大兴区',
        itemStyle: {
          areaColor: '#a28981',
          color: '#a28981'
        }
      }, {
        name: '密云区',
        itemStyle: {
          areaColor: '#d8c07e',
          color: '#d8c07e'
        }
      }, {
        name: '平谷区',
        itemStyle: {
          areaColor: '#b4dcc8',
          color: '#b4dcc8'
        }
      }, {
        name: '门头沟区',
        itemStyle: {
          areaColor: '#e1a77f',
          color: '#e1a77f'
        }
      }, {
        name: '东城区',
        itemStyle: {
          areaColor: '#aeaed4',
          color: '#aeaed4'
        }
      }],
      mapChart: '',
      map_datas: [],
    };
  },
  props: {},
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const res = await serviceTeamData(this.year)
      res.data.xiaoqu_arr.map(item => {
        item.value = [Number(item.longitude),Number(item.latitude)]
      })
      this.map_datas = res.data.xiaoqu_arr
      await this.initMap()
    },
    // 初始化地图数据
    initMap() {
      this.mapChart = echarts.init(this.$refs.map)
      window.onresize = this.mapChart.resize
      this.mapChart.setOption({
        tooltip: {        // 提示框组件
          show: true,     // 显示提示框组件
          trigger: 'item',     // 触发类型
          triggerOn: 'mousemove',  // 出发条件
          formatter: `<img style='width:20px;height:auto;' src='${require('@/assets/img/icon_marker.png')}'/>{b}`
          // formatter: `{b}<br/>`
        },
        series: {
          type: 'scatter', //配置显示方式为用户自定义
          coordinateSystem: 'geo',
          roam: false,//禁止拖拽
          data: this.map_datas
        },  // 数据
        geo: {
          map: '北京',  // 引入地图 省份或者 国家
          layoutCenter: ['50%', '50%'], //设置后left/right/top/bottom等属性无效
          layoutSize: '45%',
          roam: true, //开启鼠标缩放和漫
          zoom: 2,
          scaleLimit: {
            min: 2,
            max: 5
          },
          regions: this.colors,
          itemStyle: {   // 地图区域的多边形 图形样式。
            normal: {
              shadowBlur: 1,          // 图形阴影的模糊大小
              shadowOffsetX: 1        // 阴影水平方向上的偏移距离。
            }
          },
          label: {
            position: ['50%', '50%'],
            normal: {
              //静态的时候展示样式
              show: true, //是否显示地图省份得名称
              textStyle: {
                color: '#000',
                fontSize: 10,
                fontFamily: 'Arial'
              },
            },
            emphasis: {  // 高亮状态下的样式
              //动态展示的样式
              color: '#000'
            }
          }
        }
      })

      this.mapChart.on("click", (params) => {
        console.log(params)
        if(params.componentType === 'geo'){
          this.$emit('chioseAddress',[params.name,''])
        }else{
          this.$emit('chioseAddress',['',params.data.id])
        }
      });
    },
  },
  filters: {},
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  .chart-map {
    width: 100%;
    height: 750px;

    .map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
